import { getMomentTz } from "@dexteel/mesf-core";
import type { Printer } from "./models";

const moment = getMomentTz();

export type StatusKind = "ok" | "warn" | "error" | "off";

const STATUS: Record<string, { label: string; kind: StatusKind }> = {
	Ready: { label: "Ready", kind: "ok" },
	Paused: { label: "Paused", kind: "warn" },
	PaperOut: { label: "Out of tags", kind: "warn" },
	RibbonOut: { label: "Ribbon out", kind: "warn" },
	HeadOpen: { label: "Head open", kind: "warn" },
	Error: { label: "Error", kind: "error" },
	Offline: { label: "Offline", kind: "off" },
	ServiceDown: { label: "Service down", kind: "off" },
};

export const PRINT_STATUS_COLOR: Record<string, string> = {
	Pending: "#757575",
	Processing: "#1565c0",
	Sent: "#E65100",
	Printed: "#2e7d32",
	Expired: "#E65100",
	Cancelled: "#757575",
	Failed: "#c62828",
};

export const KIND_COLOR: Record<StatusKind, string> = {
	ok: "#2e7d32",
	warn: "#E65100",
	error: "#c62828",
	off: "#757575",
};

export const shownStatus = (p: Printer) => (p.IsActive ? p.Status : "Offline");

export const statusInfo = (status: string | null) =>
	(status && STATUS[status]) || {
		label: status ?? "Unknown",
		kind: "off" as StatusKind,
	};

// Dates come parsed from the repository; moment formats them in server time
export const formatDateTime = (d: Date | null) =>
	d ? moment(d).format("HH:mm:ss - MM/DD/YYYY") : "—";

export const formatDate = (d: Date | null) =>
	d ? moment(d).format("MM/DD/YYYY") : "—";

export const formatTime = (d: Date | null) =>
	d ? moment(d).format("HH:mm:ss") : "—";

export const formatAgo = (d: Date | null) =>
	d && moment().diff(d, "minutes") >= 2 ? moment(d).fromNow() : "";

export const tagSize = (p: {
	PrintWidth: number | null;
	LabelLength: number | null;
	Dpmm: number | null;
}) =>
	p.PrintWidth && p.LabelLength && p.Dpmm
		? `${(p.PrintWidth / p.Dpmm / 25.4).toFixed(1)} × ${(p.LabelLength / p.Dpmm / 25.4).toFixed(2)} in`
		: "—";

export const dpi = (dpmm: number | null) =>
	dpmm ? `${Math.round(dpmm * 25.4)} dpi` : null;
